import React, { useState } from 'react'

const expertiseCategories = [
  {
    title: 'Family',
    subtitle: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=900&q=80',
    description:
      'From family-only luxury hotels to kid’s adventures, we are here to guide you through all your options and then execute them perfectly.',
  },
  {
    title: 'Active',
    subtitle: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=900&q=80',
    description: 'Adventure and activity holidays for all ages and skill levels.',
  },
  {
    title: 'Cruise',
    subtitle: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=80',
    description: 'Explore the world by sea with our curated cruise experiences.',
  },
  {
    title: 'Safari',
    subtitle: 'Leisure',
    image:
      'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=900&q=80',
    description: 'Experience the wild with our exclusive safari packages.',
  },
]

const OurExpertise: React.FC = () => {
  const [current, setCurrent] = useState(0)

  const handleSelect = (idx: number) => setCurrent(idx)

  return (
    <div
      className="bg-white py-24 sm:py-32 relative"
      style={{
        background: `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('${expertiseCategories[current].image}') center/cover no-repeat`,
        transition: 'background-image 0.5s',
      }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="mx-auto max-w-2xl lg:mx-0 text-white">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Our Expertise</h2>
          <p className="mt-6 text-lg leading-8">
            Discover our specialist travel categories, handpicked for you.
          </p>
        </div>
        <div className="relative mt-16 flex items-center justify-center">
          <button
            onClick={() => setCurrent((prev) => Math.max(prev - 1, 0))}
            disabled={current === 0}
            className="absolute left-0 z-20 bg-[#58b8cd] text-white rounded-full p-3 shadow-lg disabled:opacity-50"
            aria-label="Previous"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div
            className="flex gap-6 overflow-x-auto scrollbar-hide px-16"
            style={{ scrollSnapType: 'x mandatory', minWidth: 0 }}
          >
            {expertiseCategories.map((cat, idx) => {
              const isSelected = idx === current
              return (
                <div
                  key={cat.title}
                  onClick={() => handleSelect(idx)}
                  className={`relative cursor-pointer transition-all duration-300 flex-shrink-0 ${
                    isSelected ? 'scale-105 z-10 shadow-2xl' : 'scale-95 opacity-70'
                  }`}
                  style={{
                    width: isSelected ? 340 : 260,
                    height: isSelected ? 420 : 340,
                    scrollSnapAlign: isSelected ? 'center' : 'none',
                  }}
                >
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className="w-full h-full object-cover rounded-2xl shadow-lg"
                  />
                  <div className="absolute inset-0 bg-black bg-opacity-30 flex flex-col justify-end p-6 rounded-2xl">
                    <div>
                      <h3 className="text-3xl font-bold text-white mb-2">{cat.title}</h3>
                      <div className="text-lg text-white font-medium mb-2">{cat.subtitle}</div>
                      {isSelected && <p className="text-white text-base mb-4">{cat.description}</p>}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <button
            onClick={() => setCurrent((prev) => Math.min(prev + 1, expertiseCategories.length - 1))}
            disabled={current === expertiseCategories.length - 1}
            className="absolute right-0 z-20 bg-[#58b8cd] text-white rounded-full p-3 shadow-lg disabled:opacity-50"
            aria-label="Next"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
      <div className="absolute inset-0 bg-black/30 pointer-events-none z-0" />
    </div>
  )
}

export default OurExpertise
